import Vue from 'vue';
import Vuex from 'vuex';

import functions from '@/mixins/functions';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		/* rebate_window: {
			start: dayjs().startOf(`day`),
			end: dayjs().endOf(`day`)
		},*/ // window in which the rebate is valid
		rebate_configuration: [], // the rebate keys and their corresponding part numbers available to register
		equipment_types: [], // the types of equipment customers can own
		selectedEquipmentTypeIds: [], // IDs of the owned equipment types selected in step 2
		preference: ``,
		selectedProductIds: [], // IDs of the owned products selected in step 3
		products: [], // the products available to register
		csrf_token: ``, // CSRF token
		me: { id: 0, is_support: false, account_type: 0 }, // current user
		dealershipName: ``, // company_name belonging to the dealership for the selectedCustomer
		selectedCustomer: {}, // cloud_users.users,
		countries: [], // countries in the world
		states: [], // states in the world
		orders: [], // orders for current selected customer
		loadingOrders: false,
		selectedOrder: {}, // order that was chosen in step 2.1
		uploadedFiles: [], // supporting files uploaded for the rebate
		rebate_form: {}, // contents of step 2's rebate form
		register_form: {}, // contents of step 3's register form
		registration_response: {} // response from submitting a registration. tells us what was registered/rebated
	},
	getters: {
		// rebate_window: state => state.rebate_window,
		registration_response: state => state.registration_response,
		dealershipName: state => state.dealershipName,
		loadingOrders: state => state.loadingOrders,
		me: state => state.me,
		isCustomer: state => !state.me.id || state.me.account_type == 0,
		selectedCustomer: state => state.selectedCustomer,
		selectedCustomerId: state => state.selectedCustomer.id,
		orders: state => state.orders,
		selectedOrder: state => state.selectedOrder,
		selectedOrderNumber: state => state.selectedOrder.order_number,
		uploadedFiles: state => state.uploadedFiles,
		rebateForm: state => state.rebate_form,
		countryOptions: state => state.countries.map(c => ({ value: c.id, text: c.name })),
		stateOptions: state => id =>
			state.states.filter(s => s.country_id == id).map(s => ({ value: s.id, text: s.name, state_abr: s.state_abr })),
		csrf_token: state => state.csrf_token,
		rebate_configuration: state => state.rebate_configuration,
		equipment_types: state => state.equipment_types,
		selectedEquipmentTypeIds: state => state.selectedEquipmentTypeIds,
		preference: state => state.preference,
		selectedProductIds: state => state.selectedProductIds,
		products: state => state.products,
		productByKey: state => key =>
			state.rebate_configuration.flatMap(rebate => {
				if (key !== rebate.key) return [];
				const productNames = Object
					.entries(state.products)
					.flatMap(([id, { name, rebate_key }]) =>
						rebate_key === key
							? state.selectedProductIds.length ? state.selectedProductIds.includes(+id) ? [name] : [] : [name]
							: []
					);
				return productNames.length ? [{ ...rebate, name: productNames.join(` or `) }] : [];
			})[0],
		completedRegisterForm: state => state.register_form
	},
	mutations: {
		saveRegistrationResponse (state, val) {
			state.registration_response = val;
		},
		saveDealershipName (state, val) {
			state.dealershipName = val;
		},
		loadingOrders (state, val) {
			state.loadingOrders = val;
		},
		/* saveRebateWindow (state, { end, start }) {
			state.rebate_window = { start: dayjs(start), end: dayjs(end).endOf(`day`) };
		},*/
		saveConfig (state, { csrf, rebate_configuration, equipment_types, products }) {
			Object.assign(state, { csrf_token: csrf, rebate_configuration, equipment_types, products });
		},
		saveSelectedEquipmentTypeIds (state, val) {
			state.selectedEquipmentTypeIds = val;
		},
		savePreference (state, val) {
			state.preference = val;
		},
		saveSelectedProductIds (state, val) {
			state.selectedProductIds = val;
		},
		saveRegisterForm (state, val) {
			state.register_form = val;
		},
		saveRebateForm (state, val) {
			state.rebate_form = val;
		},
		saveCustomer (state, val) {
			state.selectedCustomer = val;
		},
		saveMe (state, me) {
			state.me = me;
		},
		saveCountries (state, { states, countries }) {
			Object.assign(state, { countries, states });
		},
		saveOrders (state, orders) {
			state.orders = orders;
		},
		selectOrder (state, order) {
			state.selectedOrder = order;
		},
		saveFile ({ uploadedFiles }, file) {
			uploadedFiles.push(file);
		},
		removeFile ({ uploadedFiles }, file) {
			const i = uploadedFiles.findIndex(f => f.id === file.id);
			if (i != -1) uploadedFiles.splice(i, 1);
		}
	},
	actions: {
		selectCustomer ({ commit }, val) {
			commit(`saveCustomer`, val);
		},
		async getMe ({ commit }) {
			try {
				commit(`saveMe`, (await functions.methods.request({ action: `get_me` })).user);
			}
			catch {
				// eslint-disable-next-line no-console, no-undef
				console.log(`not logged in`);
			}
		}
	}
});